import { useState } from 'react';
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer';
import bg_contacto from '../assets/images/psicologo/bg_contacto.png'
import Modal from 'react-bootstrap/Modal';
import banner from '../assets/images/blog/banner_contacto.png'
import bg1 from '../assets/images/blog/contacto.png'
import Icocnrc from '../components/mi_icono';

export default function Contact() {
  const [show, setShow] = useState(false);
  return (
    <>
     <Navbar/> 

     <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
        <div className="bg-overlay"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title text-light"> Contacto</h4>
                            <p className="text-muted mb-0">Nos complace poder ayudarle</p>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="fw-bold text-light">Inicio</Link></li>
                            <li className="list-inline-item"><span className="text-primary fw-bold">Contacto</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
    </section>

    <ShapeTwo/>

    <section className="section">
      

      <div className="container" style={{textAlign:'justify', padding:20}}>
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4">
                         <p className="text-muted para-desc mx-auto mb-0">Favor de llenar la solicitud de contacto. <br />Pronto nos comunicaremos con usted. ¡Gracias!</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-md-8 mt-2 pt-2">
                  <div className="custom-form">
                      <form>
                          <div className="row">
                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Nombre y apellido <span className="text-danger">*</span></label>
                                      <input name="name" id="name" type="text" className="form-control" placeholder="Nombre y apellido"/>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Correo electrónico <span className="text-danger">*</span></label>
                                      <input name="email" id="email" type="email" className="form-control" placeholder="Correo electrónico"/>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Asunto <span className="text-danger">*</span></label>
                                      <input name="subject" id="subject" className="form-control" placeholder="Asunto"/>
                                  </div>
                              </div>

                               <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Teléfono de contacto <span className="text-danger">*</span></label>
                                      <input name="telefono" id="telefono" className="form-control" placeholder="Teléfono de contacto"/>
                                  </div>
                              </div>

                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Comentarios <span className="text-danger">*</span></label>
                                      <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Mensaje"></textarea>
                                  </div>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-12">
                                  <div className="d-grid">
                                      <button type="submit" id="submit" name="send" className="btn btn-primary">Enviar mensaje</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>
    
    <Footer/>

      <Modal show={show} onHide={()=>setShow(!show)} size='lg'>
        <Modal.Body>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" title='map' data-type="iframe" className="video-play-icon lightbox h6 text-white w-100" frameBorder="0" ></iframe>
        </Modal.Body>
      </Modal>
    </>
  )
}
